export default "__VITE_ASSET__29c9f802__"